// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-a47fd59e]{text-align:right}.detail[data-v-a47fd59e]{color:#666;font-size:.8em}.per[data-v-a47fd59e]{font-style:italic;text-align:center;width:100%;display:block}.spacer[data-v-a47fd59e]{height:24px}.spacer *[data-v-a47fd59e]{position:relative;top:50%}.swatch[data-v-a47fd59e]{width:12px;height:12px;content:\" \";display:block;background:#00f}.center[data-v-a47fd59e],.centered-input[data-v-a47fd59e] input{text-align:center}", ""]);
// Exports
module.exports = exports;
